/**
 * Signing in happens in flobi_auth, which sends people back here through `?app=`.
 * The session cookie is shared across *.flobi.ai, so the return trip is already signed in.
 */
export function signInUrl(): string | null {
  const { origin, pathname, search, hash } = window.location;
  const base = import.meta.env.VITE_CLERK_SIGN_IN_URL as string | undefined;
  if (!base || new URL(base, origin).origin === origin) {
    console.error(
      `VITE_CLERK_SIGN_IN_URL is ${base ? `"${base}", which is Artwork's own origin` : 'missing'}; not redirecting, it would loop. Fix .env.local and restart the dev server.`,
    );
    return null;
  }
  return `${base}?app=${encodeURIComponent(`${origin}${pathname}${search}${hash}`)}`;
}

let redirecting = false;

export function redirectToSignIn(): void {
  if (redirecting) return;
  const url = signInUrl();
  if (!url) return;
  redirecting = true;
  window.location.assign(url);
}
